import { useState, useEffect } from "react";

const API = process.env.REACT_APP_BACKEND_URL;

/**
 * Haalt de globale oefening-geschiedenis op voor de ingelogde gebruiker.
 * Retourneert een map: { "Bench Press": { kg: 80, reps: 10 }, ... }
 * gebaseerd op het beste gewicht per oefening over ALLE trainingen heen.
 */
export function useExerciseHistory(token) {
  const [history, setHistory] = useState({});

  useEffect(() => {
    if (!token) return;
    fetch(`${API}/api/workout/exercise-history`, {
      headers: { Authorization: `Bearer ${token}` },
    })
      .then(r => r.ok ? r.json() : null)
      .then(data => { if (data?.history) setHistory(data.history); })
      .catch(() => {});
  }, [token]);

  return history;
}
